import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import Day from './Day';
import Time from './Time';
import Year from './Year';
import Month from './Month';
import utils from './utils';
import Quick from './Quick';
import Quarter from './Quarter';
import paramUtils from './paramUtils';
import { getLocale } from '../locale';
import { datepickerClass } from './styles';
import { PureComponent } from '../component';

var Picker =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Picker, _PureComponent);

  var _super = _createSuper2(Picker);

  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _super.call(this, props);
    _this.defaultCurrent = void 0;
    _this.handleEnter = void 0;
    _this.handleLeave = void 0;
    var mode;

    switch (props.type) {
      case 'year':
        mode = 'year';
        break;

      case 'month':
        mode = 'month';
        break;

      case 'quarter':
        mode = 'quarter';
        break;

      case 'time':
        mode = 'time';
        break;

      default:
        mode = 'day';
    }

    _this.state = {
      mode: mode
    };
    var format = 'YYYY-MM-DD HH:mm:ss';
    _this.defaultCurrent = utils.toDateWithFormat(utils.formatDateWithDefaultTime(utils.newDate(undefined, _this.getOptions()), undefined, props.defaultTime[0], format, _this.getOptions()), format, undefined, _this.getOptions());
    _this.handleModeChange = _this.handleModeChange.bind(_assertThisInitialized(_this));
    _this.handleEnter = _this.handleMouse.bind(_assertThisInitialized(_this), true);
    _this.handleLeave = _this.handleMouse.bind(_assertThisInitialized(_this), false);
    _this.handleQuick = _this.handleQuick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Picker, [{
    key: "getOptions",
    value: function getOptions() {
      var timeZone = this.props.timeZone;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "handleQuick",
    value: function handleQuick(quick) {
      var onChange = this.props.onChange;
      onChange.apply(void 0, _toConsumableArray(paramUtils.quickHandleChangeParams(quick.value[0], true, false, false, quick)));
    }
  }, {
    key: "handleMouse",
    value: function handleMouse(isEnter, e) {
      // stop
      e.stopPropagation();
      var _this$props = this.props,
          index = _this$props.index,
          handleHover = _this$props.handleHover;
      if (handleHover && index !== undefined) handleHover(index, isEnter);
    }
  }, {
    key: "handleModeChange",
    value: function handleModeChange(mode) {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          mode: mode
        });
      }, 10);
    }
  }, {
    key: "render",
    value: function render() {
      var mode = this.state.mode;

      var _this$props2 = this.props,
          current = _this$props2.current,
          index = _this$props2.index,
          otherProps = _objectWithoutProperties(_this$props2, ["current", "index"]);

      var Render;

      switch (mode) {
        case 'year':
          Render = Year;
          break;

        case 'month':
          Render = Month;
          break;

        case 'time':
          Render = Time;
          break;

        case 'quarter':
          Render = Quarter;
          break;

        default:
          Render = Day;
      } // only range has index prop


      if (index === undefined) return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('split')
        },
        /*#__PURE__*/
        React.createElement(Quick, Object.assign({}, otherProps, {
          current: current || this.defaultCurrent,
          onChange: this.handleQuick
        })),
        /*#__PURE__*/
        React.createElement(Render, Object.assign({}, otherProps, {
          current: current || this.defaultCurrent,
          onModeChange: this.handleModeChange
        })))
      );
      return (
        /*#__PURE__*/
        React.createElement("div", {
          onMouseEnter: this.handleEnter,
          onMouseLeave: this.handleLeave
        },
        /*#__PURE__*/
        React.createElement(Render, Object.assign({}, otherProps, {
          index: index,
          current: current || this.defaultCurrent,
          onModeChange: this.handleModeChange
        })))
      );
    }
  }]);

  return Picker;
}(PureComponent);

export default Picker;